import { Layers } from "lucide-react";
import { money, pct } from "@/lib/fmt";
import { Input } from "@/components/ui/input";
import { NumInput } from "@/components/NumInput";

export const GroupsPanel = ({ summary = {}, currency, units = {}, onUnits, prices = {}, onPrices, meta = {}, onMeta, disabled }) => {
  const setMeta = (g, patch) => onMeta && onMeta({ ...meta, [g]: { ...(meta[g] || {}), ...patch } });
  const names = Object.keys(summary);
  if (!names.length) return null;
  const setPrice = (g, v) => {
    const next = { ...prices };
    if (v === "") delete next[g];
    else next[g] = Math.max(Number(v), 0);
    onPrices && onPrices(next);
  };
  return (
    <div className="rounded-lg border border-blue-200 bg-blue-50/60 p-4" data-testid="groups-panel">
      <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-blue-900"><Layers className="h-4 w-4" />Rekap grup — digabung 1 baris di PDF customer</div>
      <div className="space-y-3">
        {names.map((g, i) => {
          const s = summary[g];
          const manual = prices[g] !== undefined && prices[g] !== null && prices[g] !== "";
          const margin = s.total ? ((s.total - s.cost) / s.total) * 100 : 0;
          const m = meta[g] || {};
          const auto = `(${(s.names || []).join(", ")})`;
          return (
            <div key={g} className="rounded-md bg-white/70">
            <div className="grid items-end gap-3 p-3 text-sm md:grid-cols-[1.4fr_auto_1fr_1fr_1.2fr_0.8fr]" data-testid={`group-row-${i}`}>
              <div><p className="font-medium">{g}</p><p className="text-xs text-slate-500">{s.n} item dijabarkan</p></div>
              <div>
                <p className="text-[10px] uppercase text-slate-400">Qty 1</p>
                <select className="h-8 rounded-md border border-input bg-white px-2 text-xs" value={units[g] || "Lot"} disabled={disabled || !onUnits}
                  onChange={(e) => onUnits({ ...units, [g]: e.target.value })} data-testid={`group-unit-${i}`}>
                  <option value="Lot">Lot</option><option value="Set">Set</option>
                </select>
              </div>
              <div><p className="text-[10px] uppercase text-slate-400">Subtotal Cost</p><p className="font-num" data-testid={`group-cost-${i}`}>{money(s.cost, currency)}</p></div>
              <div><p className="text-[10px] uppercase text-slate-400">Subtotal Otomatis</p><p className="font-num" data-testid={`group-auto-${i}`}>{money(s.auto, currency)}</p></div>
              <div>
                <p className="text-[10px] uppercase text-slate-400">Harga Jual Grup (manual)</p>
                <NumInput className={`h-8 bg-white font-num ${manual ? "border-blue-500 bg-blue-50" : m.cost_only ? "border-violet-500 ring-2 ring-violet-200" : ""}`} placeholder={Math.round(s.auto).toLocaleString("id-ID")}
                  value={manual ? prices[g] : ""} disabled={disabled || !onPrices} onChange={(e) => setPrice(g, e.target.value)} data-testid={`group-price-${i}`} />
              </div>
              <div className="text-right">
                <p className="text-[10px] uppercase text-slate-400">Total • Margin</p>
                <p className="font-num font-semibold" data-testid={`group-total-${i}`}>{money(s.total, currency)}</p>
                <p className={`font-num text-xs ${margin < 0 ? "text-rose-600" : "text-emerald-700"}`} data-testid={`group-margin-${i}`}>{pct(margin)}</p>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-3 border-t border-blue-100 px-3 py-2 text-xs">
              <label className="flex items-center gap-1.5 font-semibold text-violet-700">
                <input type="checkbox" className="h-3.5 w-3.5 accent-violet-700" checked={!!m.cost_only} disabled={disabled || !onMeta}
                  onChange={(e) => setMeta(g, e.target.checked ? { cost_only: true, show: false } : { cost_only: false })} data-testid={`group-cost-only-${i}`} />
                Komponen cost saja (harga jual diisi di grup)
              </label>
              <label className="flex items-center gap-1.5 text-slate-600">
                <input type="checkbox" className="h-3.5 w-3.5 accent-blue-700" checked={m.show !== false && !m.cost_only} disabled={disabled || !onMeta || !!m.cost_only}
                  onChange={(e) => setMeta(g, { show: e.target.checked })} data-testid={`group-show-detail-${i}`} />
                Tampilkan rincian
              </label>
              <Input className="h-8 flex-1 bg-white text-xs" placeholder={auto} value={m.desc || ""} disabled={disabled || !onMeta || m.show === false || !!m.cost_only}
                onChange={(e) => setMeta(g, { desc: e.target.value })} data-testid={`group-desc-${i}`} />
              <span className="text-slate-500" data-testid={`group-desc-preview-${i}`}>PDF: <b>{g}</b>{m.show !== false && !m.cost_only ? ` — ${(m.desc || "").trim() || auto}` : ""}</span>
            </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
